import { useEffect } from "react";
import { Link } from "react-router-dom";
import Layout from "../../layout/Layout";
import cover from "../../assets/one-person-ten-people-cover.png";
import "animate.css";

function DigitalProducts() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <Layout>
      <div className="pt-16 md:pt-20 bg-white">
        <div className="flex flex-col space-y-2 sm:space-y-10 mx-auto py-2">
          <div className="flex justify-center items-center pl-6 pr-6 pb-16 md:pl-12 md:pr-12 lg:pl-24 lg:pr-24 bg-white">
            <div className="grid grid-cols-1 max-w-4xl items-stretch mx-auto gap-12">
              <p className="text-4xl md:text-5xl text-center leading-normal">
                Digital Products
              </p>
              <div className="flex flex-col justify-center items-center gap-4">
                <p className="text-xl md:text-2xl text-center leading-normal">
                  I like figuring things out. Then I turn what survived into
                  something you can actually use. This is that work, with my
                  name on it — products for people who execute, not spectators.
                </p>
                <p className="text-md md:text-lg text-slate-600 text-center leading-normal">
                  No fluff. No expired playbooks. If I wouldn&apos;t use it on a
                  hard Tuesday, I don&apos;t sell it.
                </p>
                <div className="flex flex-wrap items-center justify-center gap-4 pt-2">
                  <a
                    href="https://prabhavdev.gumroad.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="bg-black hover:bg-white hover:text-black text-white font-normal text-md py-3 px-4 border border-gray-300 rounded-xl transition duration-300 ease-in-out"
                  >
                    Gumroad Store
                  </a>
                  <a
                    href="https://payhip.prabhavdev.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="bg-black hover:bg-white hover:text-black text-white font-normal text-md py-3 px-4 border border-gray-300 rounded-xl transition duration-300 ease-in-out"
                  >
                    Payhip Store
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="flex justify-center items-center pt-16 pl-6 pr-6 pb-24 md:p-24 bg-gray-50">
            <div className="grid grid-cols-1 max-w-6xl w-full mx-auto gap-10">
              <p className="text-3xl">Browse</p>
              <Link
                to="/digital-products/ebooks"
                className="group grid grid-cols-1 lg:grid-cols-2 items-center gap-10 p-8 md:p-12 bg-white shadow-md rounded-2xl hover:shadow-lg transition-shadow duration-300"
              >
                <div className="flex flex-col space-y-5">
                  <p className="text-sm font-semibold tracking-widest uppercase text-slate-500">
                    Category
                  </p>
                  <p className="text-3xl md:text-4xl text-black">eBooks</p>
                  <p className="text-gray-700 text-md md:text-lg leading-relaxed">
                    Long-form manuals for operators who have to cover research,
                    writing, building, and selling without a ten-person team
                    behind them.
                  </p>
                  <p className="text-gray-500 text-sm">Buy on Gumroad.</p>
                  <span className="inline-flex w-fit bg-black group-hover:bg-white group-hover:text-black text-white font-normal text-md py-3 px-4 border border-gray-300 rounded-xl transition duration-300 ease-in-out">
                    Open eBooks
                  </span>
                </div>
                <div className="flex justify-center">
                  <img
                    src={cover}
                    alt="One Person, Ten People cover"
                    className="w-[180px] md:w-[220px] h-auto rounded-md shadow-lg border border-gray-200"
                  />
                </div>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}

export default DigitalProducts;
